@use '@fukuri-admins/ui/layout' as *;

.label {
  /* label domを使用するため、Stack不使用*/
  display: flex;
  align-items: center;
  gap: spacing('4');

  @include typography('Jp/14_W3');
  color: text('High');
  width: 100%;
}

.disabledLabel {
  color: text('Disabled');
}

.requiredLabel {
  @include typography('Jp/12_W3');
  color: text('Red');
}

.beforeMessage {
  @include typography('Jp/12_W3');
  color: text('Low');
}

.childrenContainer {
  flex: 1;
}
